import { UPCOMING_MARKER_COLOR, PAST_MARKER_COLOR } from '../lib/mapColors.js'

// #334: two marker colours need a key. It renders only when past events are
// actually plotted — with the default "Upcoming" range every pin is the same
// blue and a legend would just be furniture.
//
// The swatch colours are imported from the same module the pin icons read,
// so the key cannot drift from the markers it describes — and from
// `lib/mapColors.js` rather than `lib/leaflet-icons.js`, so rendering the
// legend does not drag Leaflet into jsdom.
export default function MapLegend({ pastCount }) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-slate-600">
      <span className="inline-flex items-center gap-1.5">
        <span
          className="inline-block h-3 w-3 rounded-full ring-1 ring-black/10"
          style={{ backgroundColor: UPCOMING_MARKER_COLOR }}
          aria-hidden="true"
        />
        Upcoming
      </span>
      <span className="inline-flex items-center gap-1.5">
        <span
          className="inline-block h-3 w-3 rounded-full ring-1 ring-black/10"
          style={{ backgroundColor: PAST_MARKER_COLOR }}
          aria-hidden="true"
        />
        Past ({pastCount})
      </span>
    </div>
  )
}
